// @flow

import * as React from 'react'; /* eslint-disable-line no-unused-vars */

import { Colors } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

/** @jsx isolateComponent */

type Props = {
  children: React.Node,
  trimChildren: boolean,
};

const Styles = labelStyles(__filename, {
  root: props => [
    {
      background: `linear-gradient(194.19deg, ${Colors.pink200} 0%, ${Colors.purple600} 101.17%)`,
      borderTopLeftRadius: 5,
      borderTopRightRadius: 5,
      color: Colors.white,
      overflow: 'hidden',
      textAlign: 'center',
    },
    props.trimChildren && {
      '& > *': {
        marginBottom: -10,
      },
    },
  ],
});

const TrialWelcomeModalHeader = (props: Props) => {
  return <div css={Styles.root(props)}>{props.children}</div>;
};

TrialWelcomeModalHeader.defaultProps = {
  trimChildren: false,
};

export default TrialWelcomeModalHeader;
